const e=e=>(e.define(),e);export{e as define};
//# sourceMappingURL=call-define.js.map
